import { render, staticRenderFns } from "./bodyTable.vue?vue&type=template&id=244ef2ac&scoped=true"
import script from "./bodyTable.vue?vue&type=script&lang=js"
export * from "./bodyTable.vue?vue&type=script&lang=js"
import style0 from "./bodyTable.vue?vue&type=style&index=0&id=244ef2ac&prod&lang=scss"
import style1 from "./bodyTable.vue?vue&type=style&index=1&id=244ef2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ef2ac",
  null
  
)

export default component.exports